import { Link } from "@/components/common/Link";
const pillars = [{
  label: "Infrastruttura Digitale",
  href: "#"
}, {
  label: "Espansione Globale",
  href: "#"
}, {
  label: "Logistica Industriale",
  href: "#"
}, {
  label: "Cyber Security",
  href: "#"
}];
const legalLinks = [{
  label: "Privacy Policy",
  href: "#"
}, {
  label: "Cookie Policy",
  href: "#"
}, {
  label: "Termini di Servizio",
  href: "#"
}];
const socials = [{
  label: "LN",
  href: "#"
}, {
  label: "IG",
  href: "#"
}];
export default function FondamentaFinali() {
  return <footer id="fondamenta-finali" className="dark bg-background text-foreground py-32 px-8 font-sans border-t border-border/10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 lg:gap-12">
          
          {}
          <div className="flex flex-col items-start">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/geroi_logo_footer.png" alt="geroi.eu" className="h-7 w-auto object-contain" />
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="text-sm font-bold text-foreground uppercase tracking-widest">
              Pilastri Strategici
            </h4>
            <ul className="flex flex-col gap-3">
              {pillars.map((pillar, i) => <li key={i} data-index={i}>
                  <Link to={pillar.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-300">
                    {pillar.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="text-sm font-bold text-foreground uppercase tracking-widest">
              Legale & Conformità
            </h4>
            <ul className="flex flex-col gap-3">
              <li data-index="vat">
                <span className="text-sm text-muted-foreground">
                  P.IVA: IT01234567890
                </span>
              </li>
              {legalLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="text-sm font-bold text-foreground uppercase tracking-widest">
              Contatto d'Emergenza
            </h4>
            <div className="flex flex-col gap-3 text-sm text-muted-foreground">
              <p>Linea Diretta Operazioni:</p>
              <p className="text-foreground">+39 06 1234 5678</p>
              <p>contatti@geroi.eu</p>
            </div>
            
            <div className="flex gap-6 mt-4">
              {socials.map((social, i) => <Link key={i} to={social.href} data-index={i} className="text-sm font-bold text-secondary hover:text-secondary/80 transition-colors duration-300">
                  {social.label}
                </Link>)}
            </div>
          </div>

        </div>

        {}
        <div className="mt-32 pt-8 border-t border-border/10 flex justify-center">
          <p className="text-sm text-foreground opacity-30 uppercase tracking-widest">
            Copyright GEROI Holding
          </p>
        </div>
      </div>
    </footer>;
}